module.exports = __webpack_public_path__ + "static/carousel-8-4-f122ae21c78e5ab55a50153415d1e350.png";